import {t} from "react-switch-lang";
import {useState} from 'react';
export const assessmentResultsOptions = [{
  value: '1',
  label: t('externalization.riskProponentForm.lowRisk'),
}, {
  value: '2',
  label: t('externalization.riskProponentForm.mediumRisk'),
}, {
  value: '3',
  label: t('externalization.riskProponentForm.highRisk'),
}]
export const possessionOfLicencesOptions = [{
    value: 'ALL_LICENSES_VERIFIED',
    label: t('externalization.riskProponentForm.possessionOfLicencesOptions.allLicencesVerified'),
}, {
    value: 'PARTIAL_LICENSES_ACCEPTABLE',
    label: t('externalization.riskProponentForm.possessionOfLicencesOptions.partialLicencesAcceptable'),
}, {
    value: 'MISSING_REQUIRED_LICENSES',
    label: t('externalization.riskProponentForm.possessionOfLicencesOptions.missingRequiredLicences'),
}]

export const references = [{
    value: 'REFERENCES_LAST_5_YEARS',
    label: t('externalization.riskProponentForm.referencesOptions.referencesLast5Years'),
}, {
    value: 'REFERENCES_LAST_3_YEARS',
    label: t('externalization.riskProponentForm.referencesOptions.referencesLast3Years'),
}, {
    value: 'REFERENCES_LESS_THAN_1_YEAR',
    label: t('externalization.riskProponentForm.referencesOptions.referencesLessThan1Year'),
}]
export const yesNoOptions = [
  {value: true, label: t('common.yes')},
  {value: false, label: t('common.no')}]

export const exitStrategyTriggers = [{value: "PROVIDER_BREACH", label: t('externalization.exitStrategyForm.providerBreach')},
  {value: "PROVIDER_CEASES_OPERATIONS", label: t('externalization.exitStrategyForm.providerCeasesOperations')},
  {value: "REGULATORY_OR_LEGAL_CHANGES", label: t('externalization.exitStrategyForm.regulatoryOrLegalChanges')},
  {value: "SERVICE_QUALITY_DECLINE", label: t('externalization.exitStrategyForm.serviceQualityDecline')},
  {value: "DATA_SECURITY_INCIDENTS", label: t('externalization.exitStrategyForm.dataSecurityIncidents')},
  {value: "OTHER", label: t('externalization.exitStrategyForm.other')}]

export const serviceContinuationOption = [{value: "NEW_SERVICE_PROVIDER", label: t('externalization.exitStrategyForm.newServiceProvider')},
  {value: "CONTINUE_IN_HOUSE", label: t('externalization.exitStrategyForm.continueInTheHouse')},
  {value: "DISCONTINUE_SERVICE", label: t('externalization.exitStrategyForm.discontinueService')},
  {value: "OTHER", label: t('externalization.exitStrategyForm.other')}]

export const externalizationRequiredStepsOptions = [
  {value: "IMPLEMENTATION_TEAM", label: t('externalization.exitStrategyForm.implementationTeam')},
  {value: "TRANSITION_TIMELINES", label: t('externalization.exitStrategyForm.transitionTimelines')},
  {value: "TRANSFER_TO_IN_HOUSE", label: t('externalization.exitStrategyForm.transferToInHouse')},
  {value: "ENGAGE_ALTERNATIVE_SERVICE_PROVIDER", label: t('externalization.exitStrategyForm.engageAlternativeServiceProvider')},
  {value: "TRAINING_AND_KNOWLEDGE_TRANSFER", label: t('externalization.exitStrategyForm.trainingAndKnowledgeTransfer')},
  {value: "DATA_MANAGEMENT_AND_DOCUMENT_RETURN", label: t('externalization.exitStrategyForm.dataManagementAndDocumentReturn')},
  {value: "OTHER", label: t('externalization.exitStrategyForm.other')}]

export const serviceProviderSwitchAssessmentOptions = [
  {value: "EASY_0_TO_6_MONTHS", label: t('externalization.exitStrategyForm.easy0To6Months')},
  {value: "MEDIUM_6_MONTHS_TO_2_YEARS", label: t('externalization.exitStrategyForm.medium6MonthsTo2Years')},
  {value: "HARD_2_TO_5_YEARS", label: t('externalization.exitStrategyForm.high2To5Years')}]

export const insourcingTransitionAssessmentOptions = [
  {value: "EASY_0_TO_6_MONTHS", label: t('externalization.exitStrategyForm.easy') + t('externalization.exitStrategyForm.easy0To6Months')},
  {value: "MEDIUM_6_MONTHS_TO_2_YEARS", label: t('externalization.exitStrategyForm.medium') + t('externalization.exitStrategyForm.medium6MonthsTo2Years')},
  {value: "HARD_2_TO_5_YEARS", label: t('externalization.exitStrategyForm.high') + t('externalization.exitStrategyForm.high2To5Years')},
  {value: "IMPOSSIBLE", label: t('externalization.exitStrategyForm.impossible') + t('externalization.exitStrategyForm.impossibleDesc')}]

export const externalizationStatuses = [
  {value: 'ASSESSMENT_IN_PROGRESS', label: t('externalization.externalizationStatus.assessmentInProgress')},
  {value: 'ASSESSMENT_COMPLETED', label: t('externalization.externalizationStatus.assessmentCompleted')},
  {value: 'REASSESSMENT_IN_PROGRESS', label: t('externalization.externalizationStatus.reassessmentInProgress')},
  {value: 'REASSESSMENT_COMPLETED', label: t('externalization.externalizationStatus.reassessmentCompleted')},
  {value: 'TERMINATED', label: t('externalization.externalizationStatus.terminated')},
  {value: 'EXIT_STRATEGY_ACTIVATED', label: t('externalization.externalizationStatus.exitStrategyActivated')},
]
export const allowedNextStatuses = {
  ASSESSMENT_IN_PROGRESS: ['ASSESSMENT_COMPLETED', 'TERMINATED', 'EXIT_STRATEGY_ACTIVATED'],
  ASSESSMENT_COMPLETED: ['TERMINATED', 'EXIT_STRATEGY_ACTIVATED'],
  REASSESSMENT_IN_PROGRESS: ['REASSESSMENT_COMPLETED', 'TERMINATED', 'EXIT_STRATEGY_ACTIVATED'],
  REASSESSMENT_COMPLETED: ['TERMINATED', 'EXIT_STRATEGY_ACTIVATED'],
  TERMINATED: [],
  EXIT_STRATEGY_ACTIVATED: []
};
export const statusesOfVerification = [{
  value: 'PENDING',
  label: t('externalization.statusPending'),
}, {
  value: 'REJECTED',
  label: t('externalization.statusRejected'),
}, {
  value: 'VERIFIED',
  label: t('externalization.statusVerified'),
}, {
  value: 'DRAFT',
  label: t('externalization.statusDraft'),
}]
export const getRiskLevelColor = (value) => {
  switch(value) {
    case 1:
    case 'EASY_0_TO_6_MONTHS':
      return '#37C35C';
    case 2:
    case 'MEDIUM_6_MONTHS_TO_2_YEARS':
      return '#F59A1F';
    case 3:
    case 'HARD_2_TO_5_YEARS':
      return '#F5501F';
    case 4:
    case 'IMPOSSIBLE':
      return '#7c0106';
    default:
      return 'grey';
  }
};
export const customStyles = {

  singleValue: (provided, state) => {
    const color = getRiskLevelColor(state.data?.value);
    return {
      ...provided,
      color: `${color} !important`,
      fontWeight: 'bold',
      opacity: 1,
    };
  },
}
export const isUserReviewer = (externalizationConfigData, user, formKey) => {
  if (!formKey || !externalizationConfigData || !user) return false;

  const formData = externalizationConfigData.find((form) => form?.formKey === formKey);

  if (!formData || !formData?.defaultDepartment) return false;

  const {
    userInChargeForExternalizationId,
    deputyUserInChargeForExternalizationId,
  } = formData?.defaultDepartment;

  return (
    user?.id === userInChargeForExternalizationId ||
    user?.id === deputyUserInChargeForExternalizationId
  );
};
export const searchExternalizationTemplates = (searchQuery, tableRows) => {
  const result = tableRows.filter(row => {
    const checkCondition = (item) => {
      return item.toString().toLowerCase().includes(searchQuery.toLowerCase())
    };
    const checkType = (item) => {
      return typeof item === 'string' || typeof item === 'number'
    };

    return Object.values(row).some(val => {
      let message = false;
      if (checkType(val)) {
        message = checkCondition(val);
      } else if (val !== null && val.props && val.props.array) {
        val.props.array.map(value => {
          if (val.props.nameProp) {
            if(checkType(value[val.props.nameProp]) && checkCondition(value[val.props.nameProp])){
              message = true;
            }
          } else if(checkType(value) && checkCondition(value)){
            message = true;
          }
        })
      }
      return message;
    })
  })
  return result;
}

export const handleCancelExternalization = (e) => {
  e.preventDefault();
  window.location = `/externalizations`;
};